import {
  Directive,
  Input,
  OnInit,
  ViewContainerRef,
  inject
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../dynamic-form/dynamic-form-config.interface';
import { AutocompleteComponent } from '../../autocomplete/autocomplete.component';
import { InputComponent } from '../../input/input.component';
import { SelectComponent } from '../../select/select.component';
import { CheckboxComponent } from '../../checkbox/checkbox.component';
import { BooleanSelectionComponent } from '../../boolean-selection/boolean-selection.component';
import { DateInputComponent } from '../../date-input/date-input.component';


const componentMapper = {
  input: InputComponent,
  date: DateInputComponent,
  checkbox: CheckboxComponent,
  select: SelectComponent,
  booleanSelect: BooleanSelectionComponent,
  autocomplete: AutocompleteComponent
};

@Directive({
  selector: '[dynamicField]'
})
export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  private container = inject(ViewContainerRef);

  ngOnInit(): void {
    const component:any = componentMapper[this.field.type];
    if (!component) {
      console.error(`No se encontró componente para el tipo: ${this.field.type}`);
      return;
    }

    const componentRef = this.container.createComponent(component);
    const instance = componentRef.instance as any;

    instance.field = this.field;
    instance.group = this.group;
  }
}
